export enum Options {
  ENABLE_AUTO_SUBMIT = 'enable_auto_submit',
  REQUIRE_IDENTIFIER = 'require_identifier',
  REQUIRE_APPROVAL = 'require_approval',
  FOLDER_ID = 'folder_id',
}

export interface CustomEvent {
  key: Options
  value: any
}

export interface BasicInfo {
  name: string
  description: string
  folder_id: number
}
